// nuolino-admin/src/components/layout/sidebar-sections.ts
// Config padrão da Sidebar. Constantes separadas de componentes para
// manter fast-refresh e tree-shaking limpos.

import {
  LayoutDashboard,
  Users,
  CalendarDays,
  MessageCircle,
  FileText,
  Wallet,
  Globe,
  Bell,
  FlaskConical,
  type LucideIcon,
} from 'lucide-react';

export interface SidebarItem {
  to: string;
  labelKey: string;
  icon: LucideIcon;
  badge?: number;
  end?: boolean;
}

export interface SidebarSection {
  titleKey?: string;
  items: SidebarItem[];
}

export const defaultSidebarSections: SidebarSection[] = [
  {
    items: [{ to: '/dashboard', labelKey: 'nav.dashboard', icon: LayoutDashboard, end: true }],
  },
  {
    titleKey: 'nav.sections.practice',
    items: [
      { to: '/patients', labelKey: 'nav.patients', icon: Users },
      { to: '/formulas', labelKey: 'nav.formulas', icon: FlaskConical },
      { to: '/consultations', labelKey: 'nav.consultations', icon: CalendarDays },
      { to: '/chat', labelKey: 'nav.chat', icon: MessageCircle },
      { to: '/protocols', labelKey: 'nav.protocols', icon: FileText },
    ],
  },
  {
    titleKey: 'nav.sections.revenue',
    items: [{ to: '/receipts', labelKey: 'nav.receipts', icon: Wallet }],
  },
  {
    titleKey: 'nav.sections.visibility',
    items: [
      { to: '/public-profile', labelKey: 'nav.public_profile', icon: Globe },
      { to: '/notifications', labelKey: 'nav.notifications', icon: Bell },
    ],
  },
];
